import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { CaseWorkgroupsComponent } from 'src/app/modules/cases/components/case-workgroups/case-workgroups.component';
import { CaseComponent } from 'src/app/modules/cases/pages/case/case.component';
import { CasesComponent } from 'src/app/modules/cases/pages/cases/cases.component';
import { EditCaseComponent } from 'src/app/modules/cases/pages/edit-case/edit-case.component';
import { IframeDialogComponent } from './components/iframe-dialog/iframe-dialog.component';

const routes: Routes = [
  {
    path: '',
    component: CasesComponent,
  },
  {
    path: ':id',
    component: CaseComponent,
  },
  {
    path: ':id/wijzigen',
    component: EditCaseComponent,
  },
  {
    path: ':id/werkgroepen',
    component: CaseWorkgroupsComponent,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class CasesRoutingModule {}
